'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { Paperclip } from 'lucide-react';
import { useTargetAttachments } from '../hooks/queries/useAttachments';
import { useWorkspaceScope } from '../hooks/useWorkspaceScope';
import { AttachmentBrowserModal } from './AttachmentBrowserModal';
import type { AttachmentTargetType } from '../types/attachment';

type AttachmentCountButtonProps = {
  targetType: AttachmentTargetType;
  targetId: string;
  className?: string;
};

export function AttachmentCountButton({ targetType, targetId, className }: AttachmentCountButtonProps) {
  const t = useTranslations('components.attachment');
  const { token } = useWorkspaceScope();
  const attachmentsQuery = useTargetAttachments(token, targetType, targetId);
  const [isOpen, setIsOpen] = useState(false);
  const count = attachmentsQuery.data?.length ?? 0;

  if (count === 0) return null;

  return (
    <>
      <button
        type="button"
        className={`btn btn-ghost btn-xs gap-1.5 ${className ?? ''}`}
        onClick={() => setIsOpen(true)}
        aria-label={t('viewCount', { count })}
      >
        <Paperclip className="h-3.5 w-3.5" />
        <span className="text-xs font-medium">{count}</span>
      </button>
      <AttachmentBrowserModal
        targetType={targetType}
        targetId={targetId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
